import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "There is a new version available. Do you want to restart?", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Menu = _resolveComponent("Menu")!
  const _component_Game = _resolveComponent("Game")!
  const _component_Alert = _resolveComponent("Alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.inMenu)
      ? (_openBlock(), _createBlock(_component_Menu, {
          key: 0,
          onStartGame: _ctx.startGame,
          onBackGame: _ctx.backGame,
          mayContinue: _ctx.state !== undefined
        }, null, 8, ["onStartGame", "onBackGame", "mayContinue"]))
      : _createCommentVNode("", true),
    (!_ctx.inMenu)
      ? (_openBlock(), _createBlock(_component_Game, {
          key: 1,
          state: _ctx.state,
          onToMenu: _cache[0] || (_cache[0] = ($event: any) => (_ctx.inMenu = true))
        }, null, 8, ["state"]))
      : _createCommentVNode("", true),
    _createElementVNode("footer", null, [
      _createElementVNode("p", null, [
        _createTextVNode(" © " + _toDisplayString(_ctx.copyright) + " ", 1),
        (_ctx.stateStack.length > 1 && !_ctx.inMenu)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.undo())),
              "aria-label": "Undo",
              title: "Undo"
            }, " ⭯ "))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_Alert, {
      title: "New Version Available",
      ref: "offer"
    }, {
      buttons: _withCtx(() => [
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.reloadNow()))
        }, "Reload with new version"),
        _createElementVNode("button", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$refs.offer.showModal = false))
        }, "Continue")
      ]),
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 512)
  ], 64))
}